/**
 * Comet referee-assignments API — shared paths.
 *
 * Server-side callers use NEXT_PUBLIC_COMET_DATA_API_BASE_URL directly.
 * Browser callers pass COMET_PROXY_BASE, which next.config.mjs rewrites to the
 * upstream host (same-origin → avoids the missing CORS headers).
 */

/** Same-origin proxy base for browser calls (see next.config.mjs rewrites). */
export const COMET_PROXY_BASE = '/api/comet';

/** Endpoint root (the base URL already includes /platform-comet). */
export const REFEREE_ASSIGNMENTS_PATH = '/referee-assignments';
